<!--
 * @Description: 已达上限弹窗
 * @Author: Lxc 1533761120@qq.com
 * @Date: 2024-04-20 14:18:29
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-05-11 16:02:23
-->
<script setup lang="ts">
import { Close } from '@vicons/carbon'
import coworkCodeImage from '@/assets/cowork-code.png'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  dialogTitle: {
    type: String,
    default: '',
  },
})
const emits = defineEmits(['update:modelValue', 'updateHandle'])

const showModal = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  },
})

function closeHandle() {
  showModal.value = false
  emits('updateHandle')
}
</script>

<template>
  <NModal v-model:show="showModal">
    <div class="limit-dialog">
      <div class="dialog-header flex items-center justify-between">
        <div class="title-wrap flex items-center">
          {{ dialogTitle }}
        </div>
        <button class="close-btn" @click="closeHandle">
          <NIcon :size="20" :component="Close" />
        </button>
      </div>
      <div class="dialog-body flex flex-col items-center">
        <div class="tip-wrap flex flex-col items-center">
          <slot>
            <div class="tip">
              请扫描二维码，联系客户获取更高权限吧
            </div>
          </slot>
        </div>
        <img class="img" :src="coworkCodeImage">
      </div>
    </div>
  </NModal>
</template>

<style lang="scss" scoped>
.limit-dialog {
  width: 400px;
  height: 282px;
  background: linear-gradient( 180deg, #FDFEFF 0%, #FFFFFF 100%);
  box-shadow: 0px 0px 24px 0px rgba(202,207,227,0.5);
  border-radius: 4px;
  .dialog-header {
    padding: 20px 20px 5px;
    .title-wrap {
      font-weight: 500;
      font-size: 16px;
      color: #242F57;
      line-height: 22px;
    }
    .close-btn {
      width: 20px;
      height: 20px;
    }
  }
  .dialog-body {
    padding-top: 27px;
    .tip-wrap {
      margin-bottom: 20px;
      font-size: 12px;
      color: #8FA1B2;
      line-height: 17px;
      .tip+.tip {
        margin-top: 4px;
      }
    }
    .img {
      width: 118px;
      height: 118px;
    }
  }
}
</style>
